var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-html",style:({
    'width': _vm.width,
    'padding': !_vm.isSimulation && _vm.isDesktop ? '15px 30px 15px 30px' : '0',
    '--font-size-content': (_vm.FontSizeContent + "px !important")
  })},[_c('v-flex',_vm._b({staticClass:"ql-editor ql-blank",style:({
      'color': ((_vm.customTextColorContent ? _vm.customTextColorContent : _vm.ColorContent) + " !important"), 
      'font-size': (_vm.FontSizeContent + "px !important"),
      'font-family': _vm.FontContent
    }),domProps:{"innerHTML":_vm._s(_vm.text)}},'v-flex',( _obj = {}, _obj[_vm.columnType] = true, _obj ),false)),_c('vue-editor',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],style:({ 'color': ((_vm.customTextColorContent ? _vm.customTextColorContent : _vm.ColorContent) + " !important"), 'font-size': "500px !important" }),attrs:{"disabled":true,"editor-toolbar":_vm.aux},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }